module.exports = __webpack_public_path__ + "static/ramen-truffe-mobile2-e77d0a68a4139b9864ef08c0b7f99b5e.jpg";